export default {
  v3SubmitErrBtnViewOrder: 'Просмотр заказа',
  v3SubmitErrBtnBackHome: 'На главную',
  v3SubmitErrBtnRetry: 'Повторить',
  v3SubmitErrBtnRelogin: 'Войти заново',
  v3SubmitErrBtnSwitchPay: 'Сменить способ оплаты',
  v3SubmitErrBtnReorder: 'Повторить заказ',
  v3SubmitErrBtnSwitchServer: 'Сменить сервер',
  v3SubmitErrBtnViewOrderStatus: 'Статус заказа',
  v3SubmitErrBtnBackStore: 'Вернуться в магазин',
  v3SubmitErrBtnGoUpdate: 'Обновить',
  v3SubmitErrBtnResubscribe: 'Оформить подписку заново',
  v3SubmitErrTipUpdateApp: 'Обновите в магазине приложений',
  v3SubmitErrTipRelogin: 'Пожалуйста, войдите заново',

  v3SubmitErrMsg120009: 'Заказ обработан – проверьте рюкзак в игре.',
  v3SubmitErrMsg120003: 'Ошибка в информации о товаре – выберите заново.',
  v3SubmitErrMsg120016: 'Слишком частые запросы – подождите несколько секунд и повторите.',
  v3SubmitErrMsg120025: 'Некорректные параметры запроса – войдите заново и повторите.',
  v3SubmitErrMsg121012: 'Платёжный канал временно недоступен – попробуйте другой способ.',
  v3SubmitErrMsg120012: 'Нестабильная сеть – проверьте подключение и повторите.',
  v3SubmitErrMsg120002: 'Персонаж не найден – сначала создайте персонажа.',
  v3SubmitErrMsg121019: 'Ошибка в информации о заказе – оформите новый заказ.',
  v3SubmitErrMsg120024: 'Подарок предварительной регистрации уже получен – повтор не требуется.',
  v3SubmitErrMsg120000: 'Срок сеанса истёк – войдите заново.',
  v3SubmitErrMsg120014: 'Неверный номер заказа – оформите новый заказ.',
  v3SubmitErrMsg121001: 'Пополнение в игре не удалось – повторите позже или обратитесь в поддержку.',
  v3SubmitErrMsg120015: 'Некорректная сумма платежа – выберите товар заново.',
  v3SubmitErrMsg120001: 'Сервер не соответствует – переключитесь на правильный сервер.',
  v3SubmitErrMsg120020: 'Платёжный канал вернул ошибку – попробуйте другой способ.',
  v3SubmitErrMsg120010: 'Функция пополнения временно отключена – повторите позже.',
  v3SubmitErrMsg120006: 'Проверка суммы не удалась – выберите заново.',
  v3SubmitErrMsg121010: 'Запрос пополнения в песочнице недействителен – используйте официальную версию.',
  v3SubmitErrMsg120017: 'Номер заказа дублируется – проверьте, не оплачен ли он уже.',
  v3SubmitErrMsg120022: 'Проверка платежного обратного вызова не удалась – повторите позже.',
  v3SubmitErrMsg121000: 'Система занята – повторите позже.',
  v3SubmitErrMsg120011: 'Неверный ID товара – выберите заново.',
  v3SubmitErrMsg121015: 'Проверка суммы платежа не удалась – оформите новый заказ.',
  v3SubmitErrMsg120004: 'Данный платёжный канал не открыт – выберите другой способ.',
  v3SubmitErrMsg120005: 'Платёжный канал на обслуживании – используйте другой способ.',
  v3SubmitErrMsg120007: 'Неверный ID платформы – войдите заново.',
  v3SubmitErrMsg120008: 'Недостаточно параметров запроса – отправьте заново.',
  v3SubmitErrMsg120013: 'Неверный номер заказа разработчика – оформите новый заказ.',
  v3SubmitErrMsg120018: 'Платёж заблокирован системой контроля рисков – обратитесь в поддержку для проверки.',
  v3SubmitErrMsg120019: 'Проверка имени пакета не удалась – используйте официальную версию.',
  v3SubmitErrMsg120021: 'Проверка ID товара не удалась – выберите заново.',
  v3SubmitErrMsg120023: 'Ошибка при выдаче подарка предварительной регистрации – проверьте позже.',
  v3SubmitErrMsg120026: 'Аккаунт не найден – проверьте статус аккаунта.',
  v3SubmitErrMsg120030: 'Недостаточный общий запас – выберите другой товар.',
  v3SubmitErrMsg120031: 'Превышен лимит покупки этого товара – скорректируйте.',
  v3SubmitErrMsg120032: 'Версия игры устарела – загрузите последнюю версию.',
  v3SubmitErrMsg120080: 'Платёж через агента ограничен системой контроля рисков – используйте свой способ оплаты.',
  v3SubmitErrMsg120081: 'Платёж через агента задерживается системой контроля рисков – проверьте результат позже.',
  v3SubmitErrMsg121002: 'Кэш заказа недействителен – оформите новый заказ.',
  v3SubmitErrMsg121003: 'Конфигурация пополнения не найдена – обратитесь в поддержку.',
  v3SubmitErrMsg121004: 'Недостаточно дополнительных параметров – отправьте заново.',
  v3SubmitErrMsg121005: 'Запись в кэш не удалась – повторите позже.',
  v3SubmitErrMsg121006: 'Чтение кэша не удалось – повторите позже.',
  v3SubmitErrMsg121007: 'Ошибка конфигурации типа пополнения – обратитесь в поддержку.',
  v3SubmitErrMsg121011: 'Обнаружены новые поля от Apple – обновите приложение.',
  v3SubmitErrMsg121013: 'Заказ на продление не найден – оформите подписку заново.',
  v3SubmitErrMsg121014: 'Расшифровка параметров пополнения не удалась – отправьте заново.',
  v3SubmitErrMsg121017: 'Этот заказ возвращён – обратитесь в поддержку для подтверждения.',
  v3SubmitErrMsg121018: 'Срок подписки истёк – оформите подписку заново.',
  v3SubmitErrMsg121020: 'Заказ отменён – оформите новый заказ.',
  v3SubmitErrMsg121021: 'Ошибка Google API – повторите позже.',
  v3SubmitErrMsg121022: 'Не удалось получить токен доступа – войдите заново.',
  v3SubmitErrMsg121023: 'Некорректный статус заказа – проверьте статус зачисления.',
  v3SubmitErrMsg121024: 'Подтверждение заказа не удалось – повторите позже.'
};
